<micro-select-combo #sel
              placeholder="Linked Account Type"
              [(id)]="linkedAccountTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
